<app-header></app-header>

<div class="min-h-screen">
  <div class="max-w-6xl mx-auto p-6">

    <div class="mb-6 flex items-center gap-2 text-xs text-gray-600 dark:text-gray-400">
      <a routerLink="/home" class="hover:underline text-[var(--brand-primary)]">Início</a>
      <span>/</span>
      <span>Relatórios</span>
      <span>/</span>
      <span class="font-semibold text-gray-900 dark:text-gray-100">Termos de adesão</span>
    </div>

    <app-relatorios-abas></app-relatorios-abas>

    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm overflow-hidden border border-[#E5DFD4] dark:border-gray-700">

      <div class="px-6 py-4 bg-[var(--brand-primary)]">
        <span class="font-semibold text-sm text-white">Termos de adesão</span>
      </div>

      <form class="px-6 py-5 flex flex-col sm:flex-row gap-3 sm:items-end border-b border-[#E5DFD4] dark:border-gray-700"
            (ngSubmit)="buscar()">
        <div class="flex-1 max-w-xs">
          <label for="cpf-termos" class="text-xs font-semibold mb-1 block text-gray-900 dark:text-gray-100">CPF do paciente</label>
          <input id="cpf-termos" name="cpf" type="text" inputmode="numeric" maxlength="14" autocomplete="off"
                 placeholder="000.000.000-00"
                 [ngModel]="cpf" (ngModelChange)="aoDigitar($event)"
                 class="w-full px-3 py-2 text-sm rounded-lg border border-[#E5DFD4] dark:border-gray-600 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700"/>
        </div>
        <button type="submit" [disabled]="carregando"
                class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center justify-center gap-1.5 bg-[#00AC70] hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed">
          <span *ngIf="carregando" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></span>
          {{ carregando ? 'Buscando...' : 'Buscar' }}
        </button>
      </form>

      <div *ngIf="erro" class="px-6 pt-4">
        <div class="rounded-lg px-3 py-2 text-xs bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-200">
          {{ erro }}
        </div>
      </div>

      <div *ngIf="erroDownload" class="px-6 pt-4">
        <div class="rounded-lg px-3 py-2 text-xs bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-200">
          {{ erroDownload }}
        </div>
      </div>

      <p *ngIf="!buscou && !erro" class="text-center py-10 text-xs text-gray-600 dark:text-gray-400">
        Busque pelo CPF do paciente.
      </p>

      <div *ngIf="carregando" class="px-6 py-5 space-y-2">
        <div *ngFor="let s of skeleton" class="h-8 rounded animate-pulse bg-gray-200 dark:bg-gray-700"></div>
      </div>

      <div *ngIf="!carregando && resultado" class="px-6 py-5 space-y-4">
        <div class="rounded-lg px-4 py-3 text-xs font-semibold border"
             [ngClass]="resultado.assinadoEm
               ? 'bg-green-50 dark:bg-green-900/30 border-green-200 dark:border-green-800 text-green-800 dark:text-green-200'
               : 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200'">
          <ng-container *ngIf="resultado.assinadoEm; else semAssinatura">
            Assinado digitalmente em {{ resultado.assinadoEm | date:'dd/MM/yyyy HH:mm' }}
          </ng-container>
          <ng-template #semAssinatura>Sem assinatura digital</ng-template>
        </div>

        <p *ngIf="resultado.termos.length === 0" class="text-center py-6 text-xs text-gray-600 dark:text-gray-400">
          Nenhum termo registrado para este CPF.
        </p>

        <div *ngIf="resultado.termos.length > 0" class="rounded-lg overflow-auto border border-[#E5DFD4] dark:border-gray-700" style="max-height: 480px">
          <table class="w-full text-xs">
            <thead class="sticky top-0 bg-[#0B2C45]">
              <tr>
                <th class="text-left px-3 py-2 font-semibold text-white">Data</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Forma</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Plano</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Unidade</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Operador</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Destino</th>
                <th class="text-center px-3 py-2 font-semibold text-white">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of resultado.termos" class="border-t border-[#E5DFD4] dark:border-gray-700 text-gray-900 dark:text-gray-100">
                <td class="px-3 py-2 whitespace-nowrap">{{ t.enviadoEm | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="px-3 py-2">
                  <span class="inline-block px-2 py-0.5 rounded-full font-semibold" [ngClass]="classeCanal(t.canal)">{{ rotuloCanal(t.canal) }}</span>
                </td>
                <td class="px-3 py-2">{{ t.nomePlano || '#' + t.planoId }}</td>
                <td class="px-3 py-2">{{ t.nomeUnidade || '#' + t.clinicId }}</td>
                <td class="px-3 py-2">{{ t.usuario }}</td>
                <td class="px-3 py-2">{{ t.destino }}</td>
                <td class="px-3 py-2 text-center">
                  <button *ngIf="t.podeBaixar" type="button" (click)="baixar(t)" [disabled]="baixando.has(t.id)"
                          class="px-3 py-1 rounded-lg font-semibold text-white bg-[#00AC70] hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed">
                    {{ baixando.has(t.id) ? 'Baixando…' : 'Baixar PDF' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
